module.exports = require("isomorphic-fetch");


//////////////////
// WEBPACK FOOTER
// external "isomorphic-fetch"
// module id = isomorphic-fetch
// module chunks = 3